import { Component } from '@angular/core';

@Component({
  selector: 'app-hubspot-booking-confirmation',
  templateUrl: './hubspot-booking-confirmation.component.html',
  styleUrls: ['./hubspot-booking-confirmation.component.css'],
})
export class HubspotBookingConfirmationComponent {
  constructor() {}

  isGermanVersion: boolean = true;
}
